import web from "@/core/middlewares/web";

let index = () => import(/* webpackChunkName: "groups" */ '@/views/groups/Index');
let edit = () => import(/* webpackChunkName: "groups" */ '@/views/groups/Edit');

export default [
    {
        path: "/groups",
        name: "groups.index",
        component: index,
        meta: {
            middleware: web,
            permissions: ['colleague-groups:viewAny'],
            title: "گروه ها"
        }
    },
    {
        path: "/groups/:group",
        name: "groups.edit",
        component: edit,
        meta: {
            middleware: web,
            permissions: ['colleague-groups:update'],
            title: "ویرایش همکار"
        }
    },
]
